<div>
  <div *ngIf="!isInFrame">
<!--    <clients-nside-io-header></clients-nside-io-header>-->
    <clients-nside-io-navigation-bar [hasHeader]='false'></clients-nside-io-navigation-bar>
    <hr class="header-hr" />
  </div>
  <router-outlet></router-outlet>
</div>
